module.exports = __webpack_public_path__ + "img/vip_head1.e23eaf86.png";